import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeString } from '@ipensii/shared/domain-shared';

@Pipe({
  name: 'ipSharedFormatDate',
  standalone: true,
})
export class FormatDatePipe implements PipeTransform {
  transform(dateTime: DateTimeString, locale?: string): unknown {
    return dateTime
      ? Intl.DateTimeFormat(locale || navigator.language, {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }).format(new Date(dateTime))
      : null;
  }
}
